import { strings } from '../../.localisation';
///
/// Used to get initials from name.
/// This should be removed and replaced by Initials property from server.
///
export function getInitialsFromName(name: string) {
    const result = name.replace(/[^a-zA-Z- ]/g, '').match(/\b\w/g);
    return result ? result.join('') : name;
}

export const getResultCountMessage = (resultcount: number): string => {
    if (resultcount === 0) {
        return strings.Search_Label_NoResultsFound;
    } else if (resultcount === 1) {
        return strings.Search_Label_OneResultFound;
    } else {
        return resultcount + strings.Search_Label_MoreResultsFound;
    }
};
